import React from 'react';
import Tooltip from '@mui/material/Tooltip';

const CustomTooltip = (props) => {
	const {
		placement,
		title,
		children,
		type,
		open,
		componentsProps,
		PopperProps,
		...restProps
	} = props;
	
	const defaultTooltipStyles = {
		backgroundColor: '#ffffff',
		color: 'rgba(0, 0, 0, 0.87)',
		maxWidth: "500px",
		fontSize: "14px",
		padding: "12px",
		border: type === 'report' ? '0 solid #ddd' : '1px solid #ddd',
		boxShadow: '0px 0px 15px 1px rgba(0,0,0,0.2)',
		...(componentsProps?.tooltip?.sx || {})
	};

	const mergedComponentsProps = {
		...componentsProps,
		tooltip: {
			...componentsProps?.tooltip,
			sx: defaultTooltipStyles
		},
		...(type === 'report' && {
			arrow: {
				sx: {
					color: '#ffffff !important',
				}
			}
		}),
	};
	
	return (
		<Tooltip
			placement={placement}
			title={title}
			open={open}
			arrow={type === 'report'}
			componentsProps={mergedComponentsProps}
			PopperProps={PopperProps}
			{...restProps}
		>
			{children}
		</Tooltip>
	);
}

export default CustomTooltip;
